module.exports = __webpack_public_path__ + "static/media/management-email.a66b2346.png";